/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/virtual-agent-settings-app-skeleton.tpl.svg';

const customCssStyles = css({
	margin: '0 auto',
	maxWidth: '960px',
});

export const VirtualAgentSettingsSkeleton = (): JSX.Element => (
	<AppSkeletonImage src={imgSVG} css={customCssStyles} />
);
